var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.historyPage)?_c('operator-history'):_vm._e(),(_vm.listPage)?_c('operator-list'):_vm._e(),(_vm.statisticPage)?_c('operator-statistic'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }